import AppBar from '@material-ui/core/AppBar';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import Link from '@material-ui/core/Link';
import { Link as RouteLink } from "react-router-dom";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import MenuIcon from '@material-ui/icons/Menu';
import * as React from 'react';


import navBarData from '../data/navBarPubData.json';
import { Styles, styles } from './NavBar.styles';

interface Props {
  isMobileMenuPubOpen: boolean;
  handleMobileMenuPub(isOpen: boolean): void;
}

class NavBarPub extends React.Component<Props & Styles> {
  render() {
    const {
      classes,
      handleMobileMenuPub,
      isMobileMenuPubOpen,
    } = this.props;

    const onChange = (isOpen: boolean) => (e: React.KeyboardEvent | React.MouseEvent) => {
      handleMobileMenuPub(isOpen);
    }

    const onClick = () => handleMobileMenuPub(false);

    return (
      <div className={classes.mobileContainer}>
        <AppBar elevation={0} className={classes.mobileAppBar} >
          <Toolbar className={classes.toolbarContainer}>
            <IconButton
              edge="start"
              className={classes.menuButton}
              color="inherit"
              aria-label="menu"
              onClick={onChange(true)}
            >
              <MenuIcon />
            </IconButton>
            <div className={classes.emptyContainer} />
          </Toolbar>
        </AppBar>
        <Drawer open={isMobileMenuPubOpen} onClose={onChange(false)}>
          <div onClick={onChange(false)} onKeyDown={onChange(false)}>
            <List>
              <ListItem className={classes.closeMenu}>
                <IconButton edge='end' aria-label='close' onClick={onChange(false)}>
                  <ChevronLeftIcon />
                </IconButton>
              </ListItem>
              <Divider />
              {navBarData.map((data, num) => (
                <ListItem key={num}>
                  <ListItemText inset className={classes.mobileNavItemText}>
                    { data.internal
                      ? <RouteLink to={data.link!} className={classes.mobileNavItemLink}>
                          {data.content}
                        </RouteLink>
                      : <Link href={data.link!} className={classes.mobileNavItemLink}>
                          {data.content}
                        </Link>
                    }
                  </ListItemText>
                </ListItem>
              ))}
            </List>
          </div>
        </Drawer>
        <Toolbar />
      </div>
    );
  }
}

export default withStyles(styles)(NavBarPub);
